import React from 'react';
import { useTranslation } from 'react-i18next';

const QrModal = ({ isOpen, onClose, qrData }) => {
  const { t } = useTranslation();

  if (!isOpen || !qrData) return null;

  return (
    <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center">
      {/* Backdrop */}
      <div 
        className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50"
        onClick={onClose}
      ></div>
      
      {/* Modal */}
      <div className="tw-relative tw-bg-white tw-rounded-lg tw-p-6 tw-max-w-md tw-w-full tw-mx-4 tw-z-10">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-4">
          <h3 className="tw-text-xl tw-font-semibold">
            {t('checkout.qr_payment_title')}
          </h3>
          <button 
            onClick={onClose}
            className="tw-text-gray-500 hover:tw-text-gray-700 tw-text-2xl"
          >
            &times;
          </button>
        </div>
        
        <div className="tw-text-center">
          <div className="tw-mb-4">
            <img 
              src={qrData.qr_image} 
              alt="Payment QR Code" 
              className="tw-mx-auto tw-max-w-full tw-h-auto"
            />
          </div>
          
          {qrData.message && (
            <p className="tw-mb-4 tw-text-gray-700">
              {qrData.message}
            </p>
          )}
          
          <div className="tw-mt-6">
            <button
              onClick={onClose}
              className="px-24 btn btn-main py-18 rounded-8"
            >
              {t('common.close')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QrModal; 